export default __webpack_public_path__ + "static/media/Terminal produção.4fc3a7b7.svg";